var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-body"},[_c('div',{staticClass:"m-block"},[_c('m-list-news',{attrs:{"articles":_vm.articles}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }